import {EWedletEditMode, EWedletEditModeLabel, IElementWedlet, IWedlet, IWedletActionCtx, WEDLET} from "/@back@/edit/wed/wedlets/wedlet.js";
import {DOM, JSX} from "/@lib@/commons/xml/dom.js";
import {IReg, IUiEnv} from "/@lib@/commons/registry.js";
import {DOMSH} from "/@lib@/commons/xml/domsh.js";
import {ActionBtn, Button} from "/@back@/commons/widgets/buttons.js";
import {POPUP} from "/@back@/commons/widgets/popups.js";
import {CidSession, ECidSessionState, OCidSessionConfig} from "/@lib@/core/cid.js";
import {CidInteractionByStepsUi, ICidCtx, OCidInteractionByStepsUiInit} from "/@back@/core/widgets/cidUi.js";
import {ERROR} from "/@lib@/core/errorReport.js";
import {IJmlNode} from "/@lib@/commons/xml/jml.js";
import {IUniverseEnv} from "/@lib@/core/universe.js";
import {IO} from "/@lib@/commons/io/io.js";
import {CDM} from "/@lib@/commons/utils/cdm.js";
import {IXmlMsg} from "/@lib@/edit/ot/xmlHouse.js";
import {LANG} from "/@lib@/commons/lang.js";
import {REMOTE} from "/@lib@/core/remote.js";

/**
 * Déclaration d'un bouton lié à une action, rafraichi en meme temps que le bind et que l'évolution des permissions
 *
 * <box-action-btn ui-context="bar" action="xxxxAction"/>
 *
 */
class WedletActionBtn<C extends IWedletActionCtx> extends ActionBtn<C> implements IElementWedlet {
	wedlet: IWedlet;

	configWedletElt(tpl: Element, wedlet: IWedlet): void {
		this.wedlet = wedlet;
	}

	refreshBindValue(val: IJmlNode) {
		if (this.isConnected) this.refresh();
	}

	reassessPerms() {
		if (this.isConnected) this.refresh();
	}

}

window.customElements.define('box-action-btn', WedletActionBtn);